<template>
    <span class="mb-1">
        <badge v-if="captured" type="success">
            Captured
        </badge>
        <badge v-else type="default">
            Not Captured
        </badge>
    </span>
</template>
<script>
import { Badge } from '@/components/UIComponents'
export default {
    components: {
        Badge
    },
    props: {
        captured: {
            type: Boolean
        }
    }
}
</script>

<style lang="scss" scoped>
.p-badge {
    margin-right: 0.25rem;
}
</style>
